import React from "react";
import { Info } from "lucide-react";

export default function DisclaimerBanner() {
  return (
    <div
      data-testid="disclaimer-banner"
      className="fixed bottom-0 left-0 w-full bg-amber-50 border-t border-amber-200 px-4 py-3 text-center z-50"
    >
      <div className="max-w-md mx-auto flex items-start gap-2 text-amber-900">
        <Info className="w-4 h-4 mt-0.5 flex-shrink-0" />
        <p className="text-xs font-medium tracking-wide leading-snug text-left">
          Asistente automatizado de educación legal. No somos abogados y esto no es asesoría legal.
        </p>
      </div>
    </div>
  );
}
